module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABPUlEQVRIibWVW67DIAxEx1fZF+wMe2fDyuZ+JJDQPNqm7UiIBIQP2MYAP5ZJ2g1GxH7whtwd09lkzvkbjHPADOFTA1KBmUHS0JPz2r9Pd2hmh33T5QnI/AKCl7OXgJTSC4Bj1VpnQJgdZgyx7s0BHGXbS3JAAkRSJKXlf9tm+7M2n4Pg4wRJAVDbma7aYEgr+xGwhQwAdx8mWnP3PWAxTnI0LgzQBngrTcMCZIUjwMc7EgDcdmt6FtVaQRI5Z+Sc+0XZqqgAAJLG7FI5T4AJAEopFhHaGicJd99lT0SswFJOx1b6ErdtLI58/65uxeCOegyaiyICOWe4+1C07sokdeMppX7FAfQ4fKLuolZ3jt4BSXa3DTFoLvnWYwMsLrKTgrc9wV3AFGYSgLoEMx3s3sx0F2KYC9pTfXKKn+ofZ8e98UJ7DG0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/RUN.png
// module id = 95
// module chunks = 0